import {Injectable} from '@angular/core';
import {ApibaseService} from './apibase.service';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {AlertaDetalhesVo} from '~model/vo/alerta-detalhes-vo';
import {AlertaVo} from '~model/vo/alerta-vo';
import { HttpClient, HttpParams } from '@angular/common/http';
import {ParamService} from '~core/utils/param.service';
import { PagesVo } from '~model/vo/pages-vo';

@Injectable()
export class AlertaService extends ApibaseService {

  prefixoUrl = 'controlTower';
  urlFunction = 'alertas';

  constructor(
    protected http: HttpClient,
    protected param: ParamService
  ) {
    super(http);
  }

  getAlertas(currentData?: string): Observable<AlertaVo[]> {
    const paramns = new HttpParams().append('data', currentData || this.param.dataMonitoramento);
    return super.get<AlertaVo[]>({paramns}).pipe(
      map(res => res?.map(a => ({...a, dMomento: a.dMomento ?? a.momento ? new Date(a.momento) : undefined}))),
      this.defaultCatch()
    );
  }

  getAlertasPaginados(args: {data: string, offset: number, limit: number, search?: string, visita?: string, filter?:string}): Observable<PagesVo<AlertaVo>> {
    let paramns = new HttpParams().append('offset', args.offset).append('limit', args.limit).append('data', args.data);
    if (args.search) {
      paramns = paramns.append('rota', args.search);
    }
    if (args.visita) {
      paramns = paramns.append('visita', args.visita);
    }

    if (args.filter == "atendido") {
      paramns = paramns.append('atendido', true);
      paramns = paramns.append('infoOnly', true);
    }

    if (args.filter == "infoOnly") {
      paramns = paramns.append('infoOnly', true);
    }

    console.log('---> paramns', paramns);


    return super.get<PagesVo<AlertaVo>>({extraUrl: `buscar/`, paramns})
      .pipe(
        map(page => ({
          ...page, content: page.content
            .map(a => {
              return { ...a, dMomento: a.dMomento ?? a.momento ? new Date(a.momento) : undefined };
            }),
        })),
        this.catchPagesVo(args.offset, args.limit)
      );
  }

  getAlertaDetalhesById(id: string): Observable<AlertaDetalhesVo> {
    return super.get<AlertaDetalhesVo>({extraUrl: id}).pipe(this.defaultCatch());
  }

  putAtenderAlerta(
    alerta: AlertaVo,
    { atendimento, codigoTratativa }: { atendimento: string; codigoTratativa: string }
  ): Observable<{ erro?: boolean; message: string }> {
    const queryParams = codigoTratativa ? `?codigoTratativa=${codigoTratativa}` : '';
    const sufixUrl = `atender${queryParams}`;

    return super.put(alerta.id, {
      sufixUrl,
      objEnvio: atendimento ,
    }).pipe(
      map(() => ({ message: 'Alerta atendido com sucesso!' })),
      catchError((err) => {
        const messages: { [k: number]: string } = {
          404: 'Alerta não encontrado',
          400: 'Essa operação não foi permitida',
        };
        const erro = { erro: true, message: messages[err.status] || 'Ocorreu um erro inesperado na operação' };
        return of(erro);
      })
    );
  }

  putAlertaLido(alerta: AlertaVo): Observable<{ erro?: boolean, message: string }> {
    return super.put(alerta.id, {sufixUrl: 'lida'}).pipe(
      map(_ => ({message: 'Estado do aleta modificado com sucesso!'})),
      catchError((err) => {
        const messages: {[k: number]: string} = {
          404: 'Alerta não encontrado',
          400: 'Essa operação não foi permitida',
        };
        const erro = {erro: true, message: messages[err.status] || 'Ocorreu um erro inesperado na operação'};
        return of(erro);
      })
    );
  }

  putAlertaNaoLido(alerta: AlertaVo): Observable<{ erro?: boolean, message: string }> {
    return super.put(alerta.id, {sufixUrl: 'naoLida'}).pipe(
      map(_ => ({message: 'Estado do aleta modificado com sucesso!'})),
      catchError((err) => {
        const messages: {[k: number]: string} = {
          404: 'Alerta não encontrado',
          400: 'Essa operação não foi permitida',
        };
        const erro = {erro: true, message: messages[err.status] || 'Ocorreu um erro inesperado na operação'};
        return of(erro);
      })
    );
  }

}
